/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React from 'react';
import { isAwaitingDealer, dealerSeqOf } from './epodDealerFlow';

// EPOD Phase 3 - Dealer Condition (Clean/Shortage/Damage/Reopen) brought into epodScreen.js's
// grid for CUSTOMER users, following the exact same frameworkComponent pattern already
// established by epodgateactions.js for Phase 2's Approve/Reject buttons: reads state from
// props.context.componentParent (epodScreen) and calls back its handler methods. Renders nothing
// at all unless epodScreen's own dealerConditionQueueMap (sourced 1:1 from the existing
// /billing/dealerConfirmationQueue response) says this row is present - that map is the ONLY
// eligibility signal this component ever looks at, exactly mirroring dealerConfirmationScreen.js's
// own Action column logic. The backend independently re-validates everything on the actual submit
// call regardless of what this button shows.
const DealerConditionActions = (props) => {
    const parent = props.context && props.context.componentParent;
    if (!parent) return null;

    const qrow = (parent.state.dealerConditionQueueMap || {})[String(props.data._id)];
    if (!qrow) return null;

    const options = parent.state.dealerConditionOptions || {};
    const cc = options.condition_change || {};
    const btnStyle = { padding: '2px 8px', fontSize: '12px', marginRight: '4px' };

    // Already has a dealer_confirmation_status - final, UNLESS WEB-025 reopening is enabled for
    // this caller and the reopen count for the CURRENT upload_seq hasn't hit the config max. Same
    // logic as dealerConfirmationScreen.js's Action column, read from the same API response.
    if (qrow.dealer_confirmation_status) {
        // Shortage Quantity - sourced only from this same dealer-scoped queue row
        // (qrow.ndv.shortage_quantity); shown only for a Shortage confirmation that has one.
        var shortageQtySuffix = (qrow.dealer_confirmation_condition === 'shortage' && qrow.ndv && qrow.ndv.shortage_quantity !== undefined && qrow.ndv.shortage_quantity !== null)
            ? ', qty: ' + qrow.ndv.shortage_quantity : '';
        var label = qrow.dealer_confirmation_status === 'closed_clean' ? 'Clean - Closed'
            : qrow.dealer_confirmation_status === 'closed_damage' ? 'Damage - Closed'
            : qrow.dealer_confirmation_status === 'pending_al_review'
                ? 'Pending AL Review (' + (qrow.dealer_confirmation_condition || '') + shortageQtySuffix + ')'
                : qrow.dealer_confirmation_status;

        var reopenInfo = qrow.dealer_confirmation_reopen;
        var usedCount = (reopenInfo && reopenInfo.upload_seq === dealerSeqOf(qrow)) ? (reopenInfo.count || 0) : 0;
        var maxCount = cc.max_reopen_count || 1;
        var reopenEligible = cc.dealer_reopen_enabled === true && usedCount < maxCount;
        // AL has already decided (al_approved/al_rejected) - reopenConfirmation's own
        // checkDownstreamConflict (al_review_actions has a row for EVERY AL decision, approve or
        // reject) always fails this server-side, regardless of dealer_reopen_enabled/
        // max_reopen_count. Known from the SAME qrow.dealer_confirmation_status already read above
        // - no new data needed. Disabled (not hidden) with a tooltip, since reopening is otherwise a
        // real, applicable action for this dealer - it's only THIS record that's permanently past it.
        var alreadyReviewedByAl = qrow.dealer_confirmation_status === 'al_approved' || qrow.dealer_confirmation_status === 'al_rejected';
        var canReopen = reopenEligible && !alreadyReviewedByAl;

        // Damage file viewing now lives in its own "Damage Files" grid column (damageFilesAction.js),
        // which - unlike this column - is not CUSTOMER-only, so it stays there rather than being
        // duplicated here.
        return (
            <span>
                <span style={{ marginRight: 6 }}>{label}</span>
                {canReopen ?
                    <button className="btn btn-outline-secondary" style={btnStyle}
                        onClick={(e) => { e.stopPropagation(); parent.onClickDealerConditionReopen(qrow); }}>
                        Reopen ({usedCount}/{maxCount})
                    </button>
                    : (reopenEligible && alreadyReviewedByAl ?
                        <button className="btn btn-outline-secondary" style={btnStyle} disabled
                            title="Action unavailable — this record has already been reviewed by the AL Team and can no longer be reopened.">
                            Reopen ({usedCount}/{maxCount})
                        </button>
                        : null)}
            </span>
        );
    }

    // Not yet confirmed - only offer the buttons if the queue response itself says this LR is
    // currently awaiting confirmation (never independently recomputed from epod_ocr_status or
    // anything else client-side).
    if (!isAwaitingDealer(qrow)) return null;

    // Set by requeueAfterRejection() (backend) the instant AL rejects this LR's previous NDV - the
    // row looks exactly like a never-yet-confirmed LR otherwise (status/condition/id were all
    // cleared server-side too), so without this label a Dealer would have no way to tell THIS LR
    // apart from one that was simply never actioned. Purely informational - eligibility itself is
    // already decided above by qrow.dealer_confirmation_status being absent.
    var rejectionPending = qrow.dealer_confirmation_rejection_pending;

    return (
        <span>
            {rejectionPending ?
                <span className="badge badge-danger" style={{ marginRight: 6, fontSize: '11px' }}>
                    Rejected - Resubmission Required
                </span>
                : null}
            <button className="btn btn-primary" style={btnStyle}
                onClick={(e) => { e.stopPropagation(); parent.onClickReviewPod(qrow); }}>
                Review POD
            </button>
        </span>
    );
};

export default DealerConditionActions;
